export default {
  getDietsMenu() {
    return this.http('AlibabaExerciseCheck', 'get', 'api/v1/user_diets');
  },

  getDietsMenuReset(options) {
    return this.http('AlibabaExerciseCheck', 'post', 'api/v1/user_diets/reset', options);
  }
};
